import React, { ReactElement } from 'react';
import CtaButton from './components/CtaButton';
import { useShareablePageContext } from '../../../contexts/ShareablePageContext';
import { ICreateAnalyticsEntryQuery } from '../../../interfaces';
import './styles/_cta-buttons.scss';

interface CtaButtonsProps {
  createAnalyticsEntry: ICreateAnalyticsEntryQuery;
  backgroundColor?: string;
}

export default function CtaButtons({
  createAnalyticsEntry,
  backgroundColor = '#1A1F24'
}: CtaButtonsProps): ReactElement {
  const { shareablePage } = useShareablePageContext();

  const {
    shareablePageId,
    cta,
    ctaLinkUrl,
    allowCalendarLinks,
    calendarLink
  } = shareablePage!;

  return (
    <div className="cta-buttons">
      <CtaButton
        shareablePageId={shareablePageId}
        cta={cta}
        ctaLinkUrl={ctaLinkUrl}
        createAnalyticsEntry={createAnalyticsEntry}
        color={backgroundColor}
      />
      {allowCalendarLinks && calendarLink && (
        <CtaButton
          shareablePageId={shareablePageId}
          cta="Check Availability"
          ctaLinkUrl={calendarLink}
          createAnalyticsEntry={createAnalyticsEntry}
          color={backgroundColor}
          transparent
        />
      )}
    </div>
  );
}
